import { lazy } from "react";
import { getExactHiddenRoute } from "util/react";

const PaymentRoute = getExactHiddenRoute(
    "payment",
    "menu.payment",
    "/payment",
    lazy(() => import("./index")),
    null,
);

export default PaymentRoute;
